import DialogueCard from "./DialogueCard";
import SectionHead from "./SectionHead";
import { isOpenable } from "../actions";
import { SECTION_COPY } from "../copy";

/**
 * RECOMMENDED_FOR_YOU (Figma 9154:8266) — at most three cards (a contract
 * limit, not a page), in a horizontal rail so the next card peeks in.
 *
 * Flag-off members still get platform actions mixed in here; under
 * `explore_v26_5` it is Dialogues only and the actions move to
 * SUGGESTED_ACTIONS. Either way a card that can reach nothing — a
 * dialogue-typed recommendation that resolved to no Dialogue — is dropped,
 * and a rail left empty renders nothing.
 */
function RecommendedSection({ section, onOpenDialogue }) {
  const items = (section?.items || []).filter(isOpenable);
  if (items.length === 0) return null;

  const c = SECTION_COPY.RECOMMENDED_FOR_YOU;

  return (
    <section className="ex-section">
      {/* No subtitle under Recommended for You (product 2026-10-15). */}
      <SectionHead title={c.title} />
      <div className="ex-rail ex-rail--feature">
        {items.map((card, i) => (
          <DialogueCard
            key={card.dialogue_id || card.action || i}
            card={card}
            variant="feature"
            onOpen={onOpenDialogue}
          />
        ))}
      </div>
    </section>
  );
}

export default RecommendedSection;
